import { Controller } from "@hotwired/stimulus"

// Step 1 of the donate flow (TMS-1804): keeps "Your Donation" in step with the form as the donor
// picks a fund, types an amount and chooses how often, and holds Next Step back until there is a
// fund and an amount the server will take. The server checks both again.
const AMOUNT_PATTERN = /^\d+(\.\d{1,2})?$/

export default class extends Controller {
  static targets = ["fund", "amountInput", "frequency", "fundName", "amount", "badge", "next"]
  static values = { badges: Object }

  connect() {
    this.formatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })
    this.onFundChange = () => this.sync()
    this.element.addEventListener("app-select:change", this.onFundChange)
    this.sync()
  }

  disconnect() {
    this.element.removeEventListener("app-select:change", this.onFundChange)
  }

  sync() {
    const fund = this.selectedFund()
    this.fundNameTarget.textContent = fund || "Select a fund"

    const cents = this.amountCents()
    this.amountTarget.textContent = this.formatter.format((cents || 0) / 100)

    const frequency = this.frequencyTargets.find((input) => input.checked)?.value || "one_time"
    this.badgeTarget.textContent = this.badgesValue[frequency] || ""

    this.nextTarget.disabled = !(fund && cents > 0)
  }

  // The select keeps its value in a hidden input and shows the chosen option's name on its button.
  selectedFund() {
    const hidden = this.fundTarget.querySelector("[data-app-select-target='hidden'][name]")
    if (!hidden?.value) return null

    return this.fundTarget.querySelector("[data-app-select-target='label']")?.textContent.trim() || null
  }

  amountCents() {
    const text = this.amountInputTarget.value.trim().replace(/,/g, "").replace(/^\$/, "").trim()
    if (!AMOUNT_PATTERN.test(text)) return null

    return Math.round(parseFloat(text) * 100)
  }
}
